import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style.js";

import store from "@/store/store";
import type from "../../mutationTypes.js";

function degrees_to_radian(degrees) {
  return (degrees * Math.PI) / 180;
}

export default {
  getPointsStyle(feature) {
    const rotation = feature.get("rotation");
    const label = feature.get("label");
    const size = feature.get("size");
    const color = feature.get("color");

    function getParamsForDegrees(degrees) {
      const angle = degrees_to_radian(degrees * -1);
      return angle;
    }

    const id = "points";

    if (!store.state.view.styles[id]) {
      const style = new Style({
        image: new CircleStyle({
          radius: 7,
          fill: new Fill({
            color
          })
        }),
        fill: new Fill({
          color: "rgba(255, 255, 255, 0.6)"
        }),
        stroke: new Stroke({
          color,
          width: 2
        }),
        text: new Text({
          font: `${size}px Calibri,sans-serif`,
          fill: new Fill({ color }),
          stroke: new Stroke({
            color: "#fff",
            width: 2
          }),
          rotation: getParamsForDegrees(rotation),
          text: label
        })
      });

      store.dispatch({
        type: type.setStyle,
        style: {
          id,
          style
        }
      });

      return [style];
    }

    return [store.state.view.styles[id]];
  },

  getDrawParcelStyle(feature) {
    const main = feature.get("main");
    const id = main ? "drawParcelMain" : "drawParcel";

    if (!store.state.view.styles[id]) {
      const style = new Style({
        image: new CircleStyle({
          radius: 7,
          fill: new Fill({
            color: "#b71022"
          })
        }),
        fill: new Fill({
          color: "rgba(183, 16, 34, 0.6)"
        }),
        stroke: new Stroke({
          color: main ? "#b71022" : "#b71022",
          width: main ? 4 : 2
        })
      });

      store.dispatch({
        type: type.setStyle,
        style: {
          id,
          style
        }
      });

      return [style];
    }

    return [store.state.view.styles[id]];
  },

  getStyle(feature, gf, id) {
    const type = feature.get("type");

    if (!gf.styleCache[id]) {
      var style = new Style({
        image: new CircleStyle({
          radius: 7,
          fill: new Fill({
            color: "#ffcc33"
          })
        }),
        fill: new Fill({
          color: "rgba(255, 255, 255, 0.6)"
        }),
        stroke: new Stroke({
          color: !type ? "#2222aa" : "#aa2222",
          width: !type ? 2 : 4
        })
      });

      gf.styleCache[id] = style;
    }

    return [gf.styleCache[id]];
  },

  getMeasureStyle() {
    return new Style({
      fill: new Fill({
        color: "rgba(255, 255, 255, 0.2)"
      }),
      stroke: new Stroke({
        color: "#ffcc33",
        width: 2
      }),
      image: new CircleStyle({
        radius: 7,
        fill: new Fill({
          color: "#ffcc33"
        })
      })
    });
  }
};
